<template>
    <div>
        <div class="row">
            <h1 class="page-title page-title--category">Deals</h1>
        </div>

        <div class="row agencies-filter deals-filter filter">
            <form method="get">
                <div
                    v-if="gates['deal.filter.agency.view']"
                    class="form-field form-field__select form-field--search"
                >
                    <label for="agency">Agency</label>
                    <input
                        type="text"
                        v-model="searchRequest.agency"
                        @input="search"
                        id="agency"
                    />
                </div>
                <div class="form-field form-field__select form-field--search">
                    <label for="brand">Brand</label>
                    <input
                        type="text"
                        v-model="searchRequest.brand"
                        @input="search"
                        id="brand"
                    />
                </div>
                <div class="group-filter">
                    <div class="checkbox">
                        <!-- ALL CHECKBOX -->
                        <div class="form-field checkbox-wrap">
                            <input
                                type="checkbox"
                                id="filter_status_all"
                                value="all"
                                checked
                                :ref="'filter_status_all'"
                                @change="handleCheckAllStatus"
                            />
                            <label for="filter_status_all"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            All
                        </div>
                        <!-- end ALL CHECKBOX -->
                        <div
                            class="form-field checkbox-wrap"
                            v-for="filter in statuses"
                            :key="filter.id"
                        >
                            <input
                                type="checkbox"
                                :id="`filter_status_${filter.id}`"
                                :value="filter.id"
                                @change="checkboxValue"
                                :ref="`filter_status_${filter.id}`"
                                name="status[]"
                            />
                            <label :for="`filter_status_${filter.id}`"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            {{ filter.name }}
                        </div>
                        <div class="form-field checkbox-wrap">
                            <input
                                type="checkbox"
                                :ref="'filter_without_sales'"
                                id="filter_without_sales"
                                value="false"
                                @change="checkboxValue"
                                name="withoutSales"
                            />
                            <label for="filter_without_sales"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            Without sales
                        </div>
                    </div>
                </div>
            </form>
            <div
                v-if="gates['deal.create']"
                class="form-field form-field--button form-field--button-new"
            >
                <a href="/deals/create" class="btn btn--gray">
                    <i class="icon icon-plus"></i>Add deal</a
                >
                <button
                    @click="openColumnsModal"
                    type="button"
                    class="btn btn--gray"
                >
                    Edit column view
                </button>
            </div>
        </div>

        <div
            class="row master-invoices-pagination master-invoices-pagination--top"
        ></div>

        <div class="row agencies-table agencies-table--deals">
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr
                            v-if="current_columns && current_columns.length > 0"
                        >
                            <th
                                v-for="col_obj in current_columns
                                    .filter((c) => c.status === 'show')
                                    .sort((a, b) => a.position - b.position)"
                                v-bind:key="'col_table_th_' + col_obj.id"
                                @click="sortData(col_obj.slug)"
                            >
                                <span
                                    v-if="lastSort == col_obj.slug"
                                    :class="
                                        descending &&
                                        lastSort == col_obj.slug &&
                                        'sort-icon--desc'
                                    "
                                    ><i class="icon icon-down-arrow"></i
                                ></span>
                                {{ col_obj.name }}
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td :colspan="current_columns.length + 1">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!items.length && !loading">
                            <td :colspan="current_columns.length + 1">
                                <center>No data</center>
                            </td>
                        </tr>
                        <tr
                            v-else-if="
                                searchRequest.active && filterItems.length
                            "
                            v-for="item in filterItems"
                            :key="item.id"
                        >
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].link"
                                    :href="item[_col.slug].link"
                                    :target="_col.slug === 'agency' ? '_blank' : '_self'"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{
                                        _col.is_link
                                            ? item[_col.slug].name
                                            : item[_col.slug] || "-"
                                    }}
                                </p>
                            </td>
                        </tr>
                        <tr
                            v-else-if="
                                !filterItems.length && searchRequest.active
                            "
                        >
                            <td :colspan="current_columns.length + 1">
                                <center>No data</center>
                            </td>
                        </tr>
                        <tr v-else v-for="item in items" :key="item.id">
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].link"
                                    :href="item[_col.slug].link"
                                    :target="_col.slug === 'agency' ? '_blank' : '_self'"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{
                                        _col.is_link
                                            ? item[_col.slug].name
                                            : item[_col.slug] || "-"
                                    }}
                                </p>
                            </td>
                            <td>
                                <button
                                    v-if="canDelete"
                                    @click="onDeleteDeal(item.id)"
                                    class="btn btn--icon"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row master-invoices-pagination jus-c--right"></div>

        <Column_Modal
            :is_show="showModalColumns"
            :__columns="current_columns"
            :selectColumn="selectColumn"
            :closeModal="closeModal"
            :selected_col="selected_col"
            v-if="showModalColumns"
        ></Column_Modal>

        <Confirm_Modal
            v-if="deleteDealId"
            :title="'Are you sure want to delete Deal and all related Sales and financial data?'"
            :applyLabel="'Yes'"
            :secondaryLabel="'No'"
            :onApplyAction="handleConfirmDeleteDeal"
            :onSecondaryAction="handleCancelDeleteDeal"
        />
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";
import * as sortArray from "../../parts/sort-array";
import Column_Modal from "../ColumnsModal/index.vue";
import Confirm_Modal from "../ConfirmModal/index.vue";

export default {
    name: "Deals",
    props: ["agencies", "statuses", "brands", "gates", "columns", "canDelete"],
    components: {
        ClipLoader,
        Column_Modal,
        Confirm_Modal,
    },
    data() {
        return {
            selectedStatus: [],
            agency: null,
            brand: null,
            withoutSales: false,
            loading: false,
            items: [],
            filterItems: [],
            searchRequest: {
                active: false,
                agency: "",
                brand: "",
            },
            descending: false,
            lastSort: "id",
            showModalColumns: false,
            selected_col: null,
            current_columns: [],
            filter_columns: [],

            deleteDealId: null,

            isInitPage: false,
        };
    },

    mounted() {
        this.current_columns = JSON.parse(JSON.stringify(this.columns));

        this.fetchData();
    },

    methods: {
        /*setValue(e) {
            const name = e.target.name;
            const value = e.target.value;

            this[name] = value;

            this.fetchData();
        },*/
        checkboxValue(e) {
            if (e.target.name !== "withoutSales") {
                if (e.target.checked) {
                    this.selectedStatus.push(e.target.value);
                    if (this.$refs.filter_status_all.checked) {
                        this.$refs.filter_status_all.click();
                    }
                } else {
                    this.selectedStatus = this.selectedStatus.filter(
                        (i) => i != e.target.value
                    );
                }
            } else {
                if (e.target.checked) {
                    this.withoutSales = true;
                    if (this.$refs.filter_status_all.checked) {
                        this.$refs.filter_status_all.click();
                    }
                } else {
                    this.withoutSales = false;
                }
            }

            this.fetchData();
        },

        handleCheckAllStatus(e) {
            if (e.target.checked) {
                this.selectedStatus = [];
                this.withoutSales = false;
                this.statuses.forEach((filter) => {
                    const _checkbox =
                        this.$refs[`filter_status_${filter.id}`][0];
                    if (_checkbox.checked) {
                        _checkbox.click();
                    }
                });

                const _withoutSalesCheckbox = this.$refs.filter_without_sales;

                if (_withoutSalesCheckbox.checked) {
                    _withoutSalesCheckbox.click();
                }
            }
        },

        fetchData() {
            this.loading = true;

            axios
                .post("/deals/getList", {
                    status: this.selectedStatus,
                    brand: this.brand,
                    agency: this.agency,
                    withoutSales: this.withoutSales,
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.length) {
                        this.items = this.reformatDataByColumns(res.data);
                        if (this.searchRequest.active) {
                            this.search();
                        }
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {
                    this.loading = false;
                })
                .finally(() => {
                    if (!this.isInitPage) {
                        this.getFilterFromURL();
                        this.isInitPage = true;
                    }
                });
        },
        search() {
            this.searchRequest.active =
                this.searchRequest.agency.length >= 3 ||
                this.searchRequest.brand.length >= 3;

            if (this.searchRequest.active) {
                this.filterItems = this.items.filter(
                    (item) =>
                        (this.searchRequest.agency
                            ? item.agency.name
                                  .toLowerCase()
                                  .includes(
                                      this.searchRequest.agency.toLowerCase()
                                  )
                            : true) &&
                        (this.searchRequest.brand
                            ? item.brand.name
                                  .toLowerCase()
                                  .includes(
                                      this.searchRequest.brand.toLowerCase()
                                  )
                            : true)
                );
            }
        },

        sortData(sortBy) {
            let self = this;
            if (self.lastSort !== sortBy) self.descending = false;
            self.lastSort = sortBy;
            switch (sortBy) {
                case "id":
                    self.items = self.items.sort(
                        sortArray.sortNumber("id", self.descending)
                    );
                    break;
                case "date":
                    self.items = self.items.sort(
                        sortArray.sortDate("date", self.descending, (a) =>
                            a.toUpperCase()
                        )
                    );
                    break;
                case "name":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "name",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "agency":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "agency",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "partner":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "partner",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "type":
                    self.items = self.items.sort(
                        sortArray.sortText("type", self.descending, (a) =>
                            a.toUpperCase()
                        )
                    );
                    break;
                case "status":
                    self.items = self.items.sort(
                        sortArray.sortText("status", self.descending, (a) =>
                            a.toUpperCase()
                        )
                    );
                    break;
                case "amount_invoiced":
                    self.items = self.items.sort(
                        sortArray.sortMoney("amount_invoiced", self.descending)
                    );
                    break;
                case "amount_collect":
                    self.items = self.items.sort(
                        sortArray.sortMoney("amount_collect", self.descending)
                    );
                    break;
                case "commission":
                    self.items = self.items.sort(
                        sortArray.sortMoney("commission", self.descending)
                    );
                    break;
            }
            self.descending = !self.descending;

            if (this.searchRequest.active) {
                this.search();
            }
        },

        // MODAL COLUMNS
        reformatDataByColumns(__items = []) {
            try {
                if (__items.length >= 1) {
                    const newFormatData = [];
                    if (this.current_columns.length >= 1) {
                        __items.forEach((item) => {
                            const tempObj = {};
                            this.current_columns
                                .sort((a, b) => a.position - b.position)
                                .forEach((c) => {
                                    if (c.status === "hidden") {
                                        return;
                                    }
                                    if (c.slug === "deals") {
                                        tempObj[`${c.slug}`] =
                                            item.year_deals +
                                            "(" +
                                            item.total_deals +
                                            ")";
                                        return;
                                    }
                                    if (c.slug === "invoiced") {
                                        tempObj[`${c.slug}`] =
                                            item.year_brands +
                                            "(" +
                                            item.total_brands +
                                            ")";
                                        return;
                                    }
                                    tempObj[`${c.slug}`] = item[c.slug];
                                    tempObj["brand"] = item["brand"];
                                });

                            newFormatData.push(tempObj);
                        });
                        return newFormatData;
                    }
                }

                return [];
            } catch (err) {
                console.error("reformatDataByColumns error", err);
            }
        },
        openColumnsModal() {
            this.showModalColumns = true;
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        },
        async closeModal(items = []) {
            await axios
                .post("/deals/updateColumns", {
                    columns: items,
                })
                .then(() => {
                    this.showModalColumns = false;
                    this.current_columns.length = 0;
                    this.current_columns = JSON.parse(JSON.stringify(items));
                    document.querySelector("html").style = "";
                    document.querySelector("body").style = "";
                })
                .catch((err) => {
                    console.error("Axios update columns error", err);
                });
        },
        selectColumn(col) {
            this.selected_col = col;
        },
        // Delete deal
        onDeleteDeal(id) {
            this.deleteDealId = id;
        },

        handleConfirmDeleteDeal() {
            if (this.deleteDealId) {
                axios
                    .get(`/deals/delete/${this.deleteDealId}`)
                    .then(() => {
                        this.deleteDealId = null;
                        this.fetchData();
                    })
                    .catch((err) =>
                        console.error("handleConfirmDeleteDeal", err)
                    );
            }
        },

        handleCancelDeleteDeal() {
            this.deleteDealId = null;
        },

        getFilterFromURL() {
            let params = new URLSearchParams(window.location.search);

            if (params) {
                let agency_name = params.get("agency");

                if (agency_name) {
                    this.searchRequest.agency = agency_name.toString();

                    this.search();

                    this.$forceUpdate();
                }
            }
        },
    },
};
</script>
